/*!
 * IconsViewMode - Vue icônes explorateur pour IconsView
 */

import CardView from './CardView';

export default class IconsViewMode extends CardView {
    constructor(plugin) {
        super(plugin, 'icons');
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentViewConf = myself.getViewConfig('icons') || {};
        const currentIconSize = myself.getViewIconSize('icons');

        myself.viewThumbsHeight = currentIconSize;
        myself.viewThumbsWidth = currentIconSize;
        myself.viewItemWidthRatio = currentViewConf.ratio || 1.35;
        myself.viewItemWidthMin = currentViewConf.minWidth || 120;
        myself.viewItemWidthMax = currentViewConf.maxWidth || 300;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const iconFields = myself.getViewFields('icons') || myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, iconFields);

        let countHtml = '';
        if (myself.shouldShowCount(data, 'icons')) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(myself.viewThumbsWidth, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + countHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div>';

        const currentIcon = $(code);
        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    getZoomLimits() {
        return { enabled: true, min: 32, max: 256 };
    }
}
